import * as React from 'react';

function SvgSignalCellularConnectedNoInternet1Bar(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path d='M22 8V2L2 22h16V8h4z' fillOpacity={0.3} />
			<path d='M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z' />
		</svg>
	);
}

export default SvgSignalCellularConnectedNoInternet1Bar;
